import AccountDetailReport from "./AccountDetailReport";
import AgreementsReport from "./AgreementsReport";
import CardsExpirationReport from "./CardsExpirationReport";
import POS_Summary from "./POS_Summary";

function Reports() {
  return (
    <>
      <AgreementsReport />
      <CardsExpirationReport />
      <POS_Summary />
      <AccountDetailReport />
    </>
  );
}

export default Reports;
